module.exports = __webpack_public_path__ + "img/left.89de8403.png";